// Formateadores compartidos entre la vista de finanzas de Agustín y la de un
// coach. Viven acá y no en AdminFinanzasPage para que el componente del coach
// pueda importarlos sin crear un ciclo (la página importa el componente).

export const fmtMonto = (n) => `$${Math.round(Number(n) || 0).toLocaleString('es-CL')}`;

export const fmtPct = (n) =>
  `${(Number(n) * 100).toLocaleString('es-CL', { maximumFractionDigits: 2 })}%`;

export const fmtFecha = (ymd) => {
  if (!ymd) return '—';
  const partes = String(ymd).split('-');
  if (partes.length !== 3) return ymd;
  const [y, m, d] = partes;
  return `${d}-${m}-${y}`;
};

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

/** "2026-09" → "septiembre 2026". */
export const nombreMes = (periodo) => {
  const [anio, mes] = String(periodo || '').split('-').map(Number);
  if (!anio || !mes) return periodo;
  return `${MESES[mes - 1]} ${anio}`;
};

/** El corte cae el día 15 (1ª quincena) o el último del mes (2ª quincena). */
export const nombreQuincena = (corte) => {
  const partes = String(corte || '').split('-').map(Number);
  if (partes.length !== 3) return corte;
  const [anio, mes, dia] = partes;
  if (dia === 15) return `1ª quincena de ${MESES[mes - 1]} ${anio}`;
  const mesAnt = mes === 1 ? 12 : mes - 1;
  const anioAnt = mes === 1 ? anio - 1 : anio;
  return `2ª quincena de ${MESES[mesAnt - 1]} ${anioAnt}`;
};

/**
 * Texto del diálogo que confirma el pago de una quincena.
 *
 * Vive acá y no dentro del handler para poder probarlo sin montar la página.
 * Si la quincena tiene cobros impagos lo dice con nombre y monto: registrar el
 * pago igual es válido (lo atrasado corre solo al corte siguiente, y bloquear
 * dejaría al coach sin cobrar por culpa de un moroso crónico), pero tiene que
 * ser una decisión consciente. Lo que está "por caer" NO se advierte: es el
 * curso normal de una quincena en marcha.
 */
export const mensajeConfirmacionPago = (coach, corte) => {
  const morosos = corte.morosos || [];
  const base = [
    'Marcar como pagado',
    '',
    `Coach: ${coach.nombre}`,
    nombreQuincena(corte.corte),
    `Corte: ${fmtFecha(corte.corte)}`,
    `Líquido a transferir: ${fmtMonto(corte.liquido)}`,
  ];

  if (morosos.length > 0) {
    base.push(
      '',
      `⚠ Esta quincena tiene ${morosos.length} cobro(s) sin pagar por ${fmtMonto(corte.totalMoroso)}:`,
      ...morosos.map((m) => `  · ${m.cliente} — ${fmtMonto(m.monto)} (${m.diasAtraso}d de atraso)`),
      '',
      'Si pagan después, ese monto entra al corte siguiente.',
    );
  }

  base.push('', '¿Confirmas?');
  return base.join('\n');
};
